import * as React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import ChatClient from 'fk-cp-chat';
import SimpleImage from 'components/Common/Image/SimpleImage';
import StringWidget from 'components/StringWidget/StringWidget';
import StarsWidget from 'components/StarsWidget/StarsWidget';
import getImageUrl from 'utils/getImageUrl';
import styles from './ChatProductDetails.css';
export default class ChatProductDetails extends React.Component {
    constructor(props) {
        super(props);
        this.handleViewDetailsClick = productCardData => {
            this.chatClient.sendWidgetAction(this.props.selectedChat, get(productCardData, 'data.action.params.chatMessage'));
            this.props.messageSendCallback();
        };
        this.chatClient = ChatClient.getInstance();
    }
    render() {
        const { data } = this.props;
        const buttonData = data.find(component => component.type === 'button');
        const buttonText = get(buttonData, 'data.value.text');
        const productDetailsData = data.find(component => component.type === 'productDetails');
        const value = get(productDetailsData, 'data.value');
        const { image, title, subTitle, finalPrice = 0, strikeOffPrice = 0, discountPercent = 0, rating, reviewCount = 0 } = value;
        return (<div className={styles['chat-product-details']} onClick={() => {
            this.handleViewDetailsClick(productDetailsData);
        }}>
				<div className={styles['img-container']}>
					<SimpleImage containerClass={styles['img']} src={getImageUrl(image, '300', '70')} width={80} height={88}/>
					<div className={styles['content-container']}>
						<div className={cx(styles['title'], styles['truncate-text'])}>{title}</div>
						<div className={cx(styles['subtitle'], styles['truncate-text'])}>{subTitle}</div>
						<div className={styles['pricing-details']}>
							<div className={styles['price']}>₹{Number(finalPrice).toLocaleString('en-IN')}</div>
							<div className={styles['mrp']}>{Number(strikeOffPrice).toLocaleString('en-IN')}</div>
							{discountPercent && discountPercent > 0 && (<div className={styles['saving-amount']}>
									<StringWidget attributes={{ discountAmount: discountPercent }} strKey={'discountText'}/>
								</div>)}
						</div>
						<div className={styles['ratings-and-reviews-container']}>
							<StarsWidget showStars stars={rating}/>
							<div className={styles['review-count']}>{`${reviewCount.toLocaleString('en-IN')} review${reviewCount > 1 ? 's' : ''}`}</div>
						</div>
					</div>
				</div>
				<div className={cx(styles['btn'], styles['view-details-btn'])}>{buttonText}</div>
			</div>);
    }
}
